import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import { ErrorResponse } from './ErrorResponse';
import { mapSkMaxPrice } from './mapSkMaxPrice';
import { SkMaxPrice } from './SkMaxPrice';

export interface Result {
	readonly skMaxPrice: SkMaxPrice;
}

export function resetSkMaxPrice(client: ApiClient, userId: string, groupId: string): Promise<Result> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/sk-max-price/reset');

	return client
		.fetch(url.expand({ userId, groupId }), {
			method: 'POST',
		})
		.then((response) => response.json())
		.then((response) => ({
			skMaxPrice: mapSkMaxPrice(response.skMaxPrice),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, ErrorResponse));
}
